import { useContext } from 'react';
import { APIErrorContext } from './apiErrorContext';

export const useAPIError = () => {
    return useContext(APIErrorContext);
};
